function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#545454",
  fillRule: "nonzero",
  stroke: "#545454",
  strokeWidth: 0.525
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M21.59 30c1.884 0 3.41-1.343 3.41-3V8.828c-.042-.788-.395-1.538-.999-2.121L17.378.879C16.73.329 15.868.015 14.967 0H3.409C1.526 0 0 1.343 0 3v24c0 1.657 1.526 3 3.41 3h18.18zM21 7.08h-3.606c-.77 0-1.394-.624-1.394-1.394V2.081l5 5zM2 27V3c0-.552.518-1 1.157-1h11.574v4c0 1.657 1.555 3 3.473 3h4.63v18c0 .552-.519 1-1.158 1H3.157C2.518 28 2 27.552 2 27zM6.111 7.833h4.445c.613 0 1.11-.447 1.11-1 0-.552-.497-1-1.11-1H6.11c-.614 0-1.111.448-1.111 1 0 .553.497 1 1.111 1zm.056 5.834H15.5c.644 0 1.167-.448 1.167-1 0-.553-.523-1-1.167-1H6.167c-.645 0-1.167.447-1.167 1 0 .552.522 1 1.167 1zm-.056 5.666h11.111c.614 0 1.111-.447 1.111-1 0-.552-.497-1-1.11-1H6.11c-.614 0-1.111.448-1.111 1 0 .553.497 1 1.111 1zm6.18 3.5h-6.25c-.575 0-1.041.448-1.041 1 0 .553.466 1 1.042 1h6.25c.575 0 1.041-.447 1.041-1 0-.552-.466-1-1.041-1z",
  transform: "translate(-644 -767) translate(644 767) translate(8.333 5)"
})))));

var SvgIconProductType = function SvgIconProductType(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconProductType, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-product-type.4dae7c19.svg";
export { ForwardRef as ReactComponent };